const preselectVariantFromURL = ({
  variantsData,
  optionNames,
  form,
  selectedOptions,
  sellingPlanIdInput,
  updateSelectedOption,
  updateVariantDetails,
  variantsDropdownTriggers
}) => {
  const url = new URL(window.location.href);
  const variantIdFromURL = url.searchParams.get('variant');
  const sellingPlanFromURL = url.searchParams.get('selling_plan');

  if (!variantIdFromURL) return;

  const variant = variantsData.find(v => String(v.id) === variantIdFromURL);
  if (!variant) return;

  optionNames.forEach((name, i) => {
    const value = variant[`option${i + 1}`];
    selectedOptions[name] = value;

    const input = form.querySelector(`[name="${name}"][value="${value}"]`);
    if (input) {
      input.checked = true;
      const labelText = input.nextElementSibling?.innerHTML || '';
      const triggerLabel = variantsDropdownTriggers[i]?.nextElementSibling?.querySelector('[data-variants-selected-option]');
      if (triggerLabel) triggerLabel.innerHTML = labelText;
    } else {
      const select = form.querySelector(`select[name="${name}"]`);
      if (select) select.value = value;
    }

    updateSelectedOption(name, value);
  });
  if (sellingPlanFromURL && sellingPlanIdInput) {
    sellingPlanIdInput.value = sellingPlanFromURL;

    const sellingPlanRadio = form.querySelector(`[data-selling-plan-radio][value="${sellingPlanFromURL}"]`);
    if (sellingPlanRadio) {
      sellingPlanRadio.checked = true;

      sellingPlanRadio.dispatchEvent(new Event('change', { bubbles: true }));

      const label = sellingPlanRadio.nextElementSibling;
      const freqTrigger = form.querySelector('[data-subscription-frequency]');
      const freqSelectedEl = form.querySelector('[data-subscription-frequency-selected]');
      const saveEl = form.querySelector('[data-subscription-saving]');
      const subscriptionInput = form.querySelector('[data-selling-plan-subscription]');

      if (label && sellingPlanRadio.hasAttribute('data-selling-plan-frequency')) {
        if (freqSelectedEl) freqSelectedEl.textContent = label.textContent;
        if (saveEl) saveEl.textContent = label.dataset.sellingPlanAdjustment || '';
      }

      if (subscriptionInput && !subscriptionInput.checked) {
        subscriptionInput.checked = true;
        subscriptionInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (freqTrigger && freqTrigger.checked) {
        freqTrigger.checked = false;
      }
    }
  }
  updateVariantDetails();
};

export default preselectVariantFromURL;
